/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import useNotifications from '../../../../hooks/useNotifications'
import useAuth from '../../../../hooks/useAuth'
import {NotificationsPanel} from './NotificationsPanel'

const HeaderNotificationsMenu: FC = () => {
  const {fetchNotifications} = useNotifications()
  const {me} = useAuth()

  const handleSeeAll = () => {
    if (me?._id) fetchNotifications({recipient: me._id})
  }

  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column w-350px w-lg-375px'
      data-kt-menu='true'
    >
      <div className='tab-content p-0'>
        <div className='tab-pane fade show active' id='kt_topbar_notifications_1' role='tabpanel'>
          <NotificationsPanel onSeeAllClick={handleSeeAll} />
        </div>
      </div>
    </div>
  )
}

export {HeaderNotificationsMenu}
